module.exports = __webpack_public_path__ + "img/icon_exe_leitora.2dd91067.png";